import { TranslationsAppState } from './types';

export const getTranslation = ({ translations }: TranslationsAppState, keyName: string): string | undefined =>
    translations.translations[keyName];
